module.exports = __webpack_public_path__ + "static/media/video-folder.e81cab47.svg";